/**
 * Meddelande om ändring – införande av förhandlingsklausul (12 kap. 54 § JB).
 *
 * Same two-part shape as `andring_hyresvillkor`, § numbering restarting
 * per part.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
import { ANDRING_HOST_META, ANDRING_PARTY_SLOTS, MEDDELANDE_SIGNERS, TILLAGG_SIGNERS } from './andring_hyresvillkor.js';
const TITLE = 'Meddelande om ändring – införande av förhandlingsklausul';
const FORM_NUMBER = 'Formulär R-12';
export const andringHyresvillkorForhandlingsklausulV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'andring_hyresvillkor_forhandlingsklausul',
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: {
        category: 'Ändring av hyresvillkor',
        numberStyle: 'paragraph',
        shortTitle: 'Ändring — införande av förhandlingsklausul',
        formNumber: FORM_NUMBER,
        statute: '12 kap. 54 § jordabalken',
        signingMode: 'manual_delivery',
        ...ANDRING_HOST_META,
        preamble: 'Hyresvärden meddelar härmed hyresgästen om föreslagen ändring av hyresvillkoren genom införande av förhandlingsklausul.',
        description: 'Enligt 12 kap. 54 § jordabalken.\n\n' +
            'Specialvariant av "Meddelande om ändring av hyresvillkor" där det som föreslås är att en förhandlingsklausul ska införas i hyresavtalet. Lagtexten i tillägget är förtryckt — använd den generiska mallen "Ändring av hyresvillkor" om andra villkor ska ändras.\n\n' +
            'Vem undertecknar: hyresvärden (meddelandet) och hyresgästen — samt eventuell medhyresgäst — (tillägget).\n' +
            'Leverans: skickas via Scrive.\n\n' +
            'Om hyresgästen inte skriver under tillägget inom svarsfristen får hyresvärden lämna in ärendet till hyresnämnden, dock tidigast en månad efter att meddelandet lämnats.\n\n' +
            'Kopplad mall — skapas under det bostadshyresavtal som ändringen avser.',
        partySlots: ANDRING_PARTY_SLOTS,
        propertySlots: [{ id: 'property', label: 'Fastighet', multi: false, required: true }],
    },
    parts: [
        { key: 'meddelande', title: 'Meddelande om ändring av hyresvillkor' },
        { key: 'tillagg', title: 'Tillägg till hyresavtalet' },
    ],
    values,
    blocks: [
        {
            instanceId: 'letterhead-meddelande',
            blockRef: 'common.letterhead@v1',
            part: 'meddelande',
            slot: 'letterhead',
            input: { title: TITLE, form_number: FORM_NUMBER },
        },
        {
            instanceId: 'footer-meddelande',
            blockRef: 'common.page-footer@v1',
            part: 'meddelande',
            slot: 'footer',
            input: { form_number: FORM_NUMBER },
        },
        { instanceId: 'rubrik', blockRef: 'andring_hyresvillkor_forhandlingsklausul.rubrik@v1', part: 'meddelande', input: {} },
        { instanceId: 'uppgifter-meddelande', blockRef: 'andring_hyresvillkor.uppgifter@v1', part: 'meddelande', input: {} },
        {
            instanceId: 'meddelande',
            blockRef: 'andring_hyresvillkor_forhandlingsklausul.meddelande@v1',
            part: 'meddelande',
            input: {},
        },
        {
            instanceId: 'underskrift-av-meddelandet',
            blockRef: 'andring_hyresvillkor_forhandlingsklausul.underskrift-meddelande@v1',
            part: 'meddelande',
            input: {
                ref: 'underskrift-av-meddelandet',
                title: 'Underskrift av meddelandet',
                heading: false,
                parties: MEDDELANDE_SIGNERS,
            },
        },
        {
            instanceId: 'letterhead-tillagg',
            blockRef: 'common.letterhead@v1',
            part: 'tillagg',
            slot: 'letterhead',
            input: { title: TITLE, form_number: FORM_NUMBER },
        },
        {
            instanceId: 'footer-tillagg',
            blockRef: 'common.page-footer@v1',
            part: 'tillagg',
            slot: 'footer',
            input: { form_number: FORM_NUMBER },
        },
        { instanceId: 'tillagg-rubrik', blockRef: 'andring_hyresvillkor.tillagg-rubrik@v1', part: 'tillagg', input: {} },
        { instanceId: 'uppgifter-tillagg', blockRef: 'andring_hyresvillkor.uppgifter@v1', part: 'tillagg', input: {} },
        { instanceId: 'tillagg-ingress', blockRef: 'andring_hyresvillkor.tillagg-ingress@v1', part: 'tillagg', input: {} },
        {
            instanceId: 'andrade-hyresvillkor',
            blockRef: 'andring_hyresvillkor_forhandlingsklausul.andrade-hyresvillkor@v1',
            part: 'tillagg',
            input: { numbering: 'auto' },
        },
        {
            instanceId: 'underskrift-av-tillagget',
            blockRef: 'andring_hyresvillkor_forhandlingsklausul.underskrift@v1',
            part: 'tillagg',
            input: {
                ref: 'underskrift-av-tillagget',
                title: 'Underskrift av tillägget',
                numbering: 'auto',
                heading: false,
                parties: TILLAGG_SIGNERS,
            },
        },
    ],
});
//# sourceMappingURL=andring_hyresvillkor_forhandlingsklausul.js.map